/* Studio Mins — mesafeli satis sozlesmesi onay kutusu
   Sepette ve sepet cekmecesinde onay kutusu gosterir, onaylanmadan
   odemeye gecisi engeller ve onayi sepet ozelligi olarak kaydeder,
   boylece siparisin yaninda gorunur. */
(function () {
  'use strict';

  var ATTR = 'Mesafeli satış sözleşmesi onayı';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isTR = (document.documentElement.lang || 'tr').toLowerCase().indexOf('tr') === 0;

  var T = isTR
    ? {
        label:
          '<a href="' + root + 'pages/on-bilgilendirme-formu" target="_blank" rel="noopener">Ön Bilgilendirme Formu</a>' +
          "'nu ve " + '<a href="' + root + 'pages/mesafeli-satis-sozlesmesi" target="_blank" rel="noopener">Mesafeli Satış Sözleşmesi</a>' +
          "'ni okudum, onaylıyorum.",
        error: 'Devam etmek için sözleşmeleri onaylamanız gerekiyor.',
        value: 'Onaylandı'
      }
    : {
        label:
          'I have read and accept the <a href="' + root + 'pages/on-bilgilendirme-formu" target="_blank" rel="noopener">Pre-Sale Information Form</a>' +
          ' and the <a href="' + root + 'pages/mesafeli-satis-sozlesmesi" target="_blank" rel="noopener">Distance Sales Agreement</a>.',
        error: 'Please accept the agreements to continue.',
        value: 'Accepted'
      };

  var accepted = false;
  var itemCount = null;
  var saving = false;

  function style() {
    if (document.getElementById('sm-consent-style')) return;
    var s = document.createElement('style');
    s.id = 'sm-consent-style';
    s.textContent = [
      '.sm-consent{display:flex;align-items:flex-start;gap:9px;width:100%;order:2;margin-block:2px 0;}',
      '.cart__ctas{order:3;}',
      '.cart-totals{order:1;}',
      '.sm-consent input{appearance:auto;width:15px;height:15px;margin:2px 0 0;flex:0 0 auto;cursor:pointer;}',
      '.sm-consent label{font-size:12.5px;line-height:1.5;cursor:pointer;}',
      '.sm-consent a{text-decoration:underline;color:inherit;}',
      '.sm-consent--error label{color:#B3261E;}',
      '.sm-consent--error input{outline:2px solid #B3261E;outline-offset:2px;}',
      '.sm-consent-msg{width:100%;order:2;font-size:12.5px;line-height:1.5;color:#B3261E;margin:0;}',
      '.sm-blocked{opacity:.45;pointer-events:none;}'
    ].join('');
    document.head.appendChild(s);
  }

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        itemCount = c.item_count;
        var v = c.attributes && c.attributes[ATTR];
        accepted = !!(v && String(v).length);
        sync();
      })
      .catch(function () {});
  }

  function saveCart(on) {
    if (saving) return;
    saving = true;
    var attrs = {};
    attrs[ATTR] = on ? T.value + ' — ' + new Date().toISOString() : '';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') itemCount = c.item_count; })
      .catch(function () {})
      .then(function () { saving = false; });
  }

  function build(ctas) {
    var box = document.createElement('div');
    box.className = 'sm-consent';
    box.setAttribute('data-sm-consent', '');

    var id = 'sm-consent-' + Math.random().toString(36).slice(2, 8);
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.id = id;

    var label = document.createElement('label');
    label.setAttribute('for', id);
    label.innerHTML = T.label;

    box.appendChild(input);
    box.appendChild(label);

    input.addEventListener('change', function () {
      accepted = input.checked;
      saveCart(accepted);
      sync();
    });

    ctas.parentNode.insertBefore(box, ctas);
    return box;
  }

  function flag(box) {
    box.classList.add('sm-consent--error');
    var msg = box.parentNode.querySelector('.sm-consent-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'sm-consent-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = T.error;
      box.parentNode.insertBefore(msg, box.nextSibling);
    }
    window.setTimeout(function () {
      box.classList.remove('sm-consent--error');
      if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
    }, 6000);
  }

  function sync() {
    var groups = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < groups.length; i++) {
      var ctas = groups[i];
      var box = ctas.parentNode.querySelector('[data-sm-consent]');
      if (!box) box = build(ctas);

      var empty = itemCount === 0;
      box.style.display = empty ? 'none' : '';

      var input = box.querySelector('input');
      if (input.checked !== accepted) input.checked = accepted;

      var btn = ctas.querySelector('#checkout, [name="checkout"]');
      if (btn) {
        btn.disabled = empty || !accepted;
        if (!btn.dataset.smGuard) {
          btn.dataset.smGuard = '1';
          btn.addEventListener('click', function (e) {
            if (!accepted) {
              e.preventDefault();
              e.stopPropagation();
              var b = this.closest('.cart__ctas').parentNode.querySelector('[data-sm-consent]');
              if (b) flag(b);
            }
          });
        }
      }

      var fast = ctas.querySelector('.additional-checkout-buttons');
      if (fast) fast.classList.toggle('sm-blocked', !accepted);
    }
  }

  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { sync(); }, 60);
  }

  function start() {
    style();
    readCart();
    sync();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:update', readCart);
    document.addEventListener('cart:refresh', readCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
